import React, { useContext } from "react";
import { ProductContext } from "../../context/ProductContext";

const DirectionUse: React.FC = () => {
  const context = useContext(ProductContext);

  if (!context?.product?.directionsToUse) return null;

  const headingColor = context.product.headingColor || "#000000";
  const textColor = context.product.textColor || "#000000";
  const headingFontStyle = context.product.headingFontStyle;
  const fontStyle = context.product.fontStyle;

  return (
    <div className="w-full max-w-2xl mx-auto px-4 py-5 font-mulish text-left">
      <h2 style={{ letterSpacing: "0.01em", color: headingColor, fontFamily:headingFontStyle }} className="text-base font-bold text-gray-900 leading-tight pb-2">
        Directions to Use
      </h2>
      <p style={{color: textColor, fontFamily: fontStyle}} className="text-sm mt-1 leading-snug">
        {context.product.directionsToUse}
      </p>
    </div>
  );
};

export default DirectionUse;
